module.exports = __webpack_public_path__ + "img/ssb_logo.c6dcbf6b.png";